/* eslint-disable max-classes-per-file */
export interface RequestNewFlightSeoInterface {
  countrySlug: string;
  citySlug?: string;
  limit?: number;
  page?: number;
}
export interface Root {
  status: boolean;
  message: string;
  flightOffer: Data;
}

export interface Data {
  breadcrumbs: Breadcrumbs;
  flightOffer: FlightOffer[];
}

export interface Breadcrumbs {
  countryName: string;
  countrySlug: string;
  countryLatitude: string;
  countryLongitude: string;
  cityName: string;
  citySlug: string;
  cityLatitude: string;
  cityLongitude: string;
}

export class BoxSearchSEODeparture {
  name: string;

  slug: string;

  code: string;

  cityName: string;

  countryName: string;

  citySlug: string;

  countrySlug: string;

  lang: {
    airportName: string;
    cityName: string;
    countryName: string;
  };

  constructor(data: any) {
    this.name = data?.name || null;
    this.slug = data?.slug || null;
    this.code = data?.code || null;
    this.cityName = data?.cityName || null;
    this.countryName = data?.countryName || null;
    this.citySlug = data?.citySlug || null;
    this.countrySlug = data?.countrySlug || null;
    this.lang = data?.lang || {
      airportName: "",
      cityName: "",
      countryName: "",
    };
  }
}

export class BoxSearchSEOArrival {
  name: string;

  slug: string;

  code: string;

  cityName: string;

  countryName: string;

  citySlug: string;

  countrySlug: string;

  lang: {
    airportName: string;
    cityName: string;
    countryName: string;
  };

  constructor(data: any) {
    this.name = data?.name || null;
    this.slug = data?.slug || null;
    this.code = data?.code || null;
    this.cityName = data?.cityName || null;
    this.countryName = data?.countryName || null;
    this.citySlug = data?.citySlug || null;
    this.countrySlug = data?.countrySlug || null;
    this.lang = data?.lang || {
      airportName: "",
      cityName: "",
      countryName: "",
    };
  }
}

export class BoxSearchSEO {
  departure: BoxSearchSEODeparture;

  arrival: BoxSearchSEOArrival;

  constructor(data: any) {
    this.departure = new BoxSearchSEODeparture(data?.departure || {});
    this.arrival = new BoxSearchSEOArrival(data?.arrival || {});
  }
}

interface AirportInCountry {
  airportName: string;
  airportCode: string;
  airportSlug: string;
}

interface CityInCountry {
  citySlug: string;
  cityName: string;
}

export interface FlightOffer {
  flightOfferId: string;
  price: number;
  flightType: string;
  ticketingPeriod: string;
  travelPeriod: string;
  slug: string;
  intro: string;
  photoPath: string;
  fromAirportCode: string;
  toAirportCode: string;
  flightDescription: string;
  airlineSlug: string;
  airlineName: string;
  cityFromName: string;
  cityFromSlug: string;
  cityToName: string;
  cityToSlug: string;
  airlineLogo: string;
  dateSearchDeparture: string;
  dateSearchReturn: string;
  ticketingFromDate: string;
  ticketingToDate: string;
  travelFromDate: string;
  travelToDate: string;
  currency: string;
  cityName: string;
  citySlug: string;
  cityNameFrom: string;
  cityNameTo: string;
  flightOfferSlug: string;
  flightName: string;
  airportCityTo: string;
  airportCityFrom: string;
}
export class ResponseNewFlightSeo {
  status: boolean;

  message: string;

  breadcrumbs: Breadcrumbs;

  boxSearch: BoxSearchSEO;

  flightOffer: FlightOffer[];

  airportInCountry: AirportInCountry[];

  cityInCountry: CityInCountry[];

  hasAirport: boolean;

  constructor(data: any) {
    this.status = data.status || false;
    this.message = data.message || "";
    this.breadcrumbs = data.breadcrumbs || "";
    this.flightOffer = data.flightOffer || null;
    this.airportInCountry = data.airportInCountry || null;
    this.cityInCountry = data.cityInCountry || null;
    this.hasAirport = data.hasAirport || false;
    this.boxSearch = data?.boxSearch || null;
  }
}
